export const baseUrl = "https://value-realitty-backend-665385455484.asia-south1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "Value Realitty";
